(function () {
  function syncCartLabels() {
    document
      .querySelectorAll('a[href*="#offcanvas-cart"], button[aria-label*="Cart"], [aria-label^="Cart"]')
      .forEach(function (trigger) {
        var badge = trigger.querySelector('.cart-count-badge, [data-count]');
        var rawCount = badge ? (badge.getAttribute('data-count') || badge.textContent || '').trim() : '';
        var match = rawCount.match(/\d+/);

        if (match) {
          trigger.setAttribute('aria-label', 'Cart ' + match[0]);
        }
      });
  }

  function markEmptySocialLinks() {
    document.querySelectorAll('.social-icons a[href="#"], .social-icons a[href$="/#"]').forEach(function (link) {
      link.setAttribute('aria-disabled', 'true');
      link.addEventListener('click', function (event) {
        event.preventDefault();
      });
    });
  }

  function waitForPayU(callback, fallback, attempts) {
    attempts = attempts || 0;

    if (window.payU && typeof window.payU.openModal === 'function') {
      callback();
      return;
    }

    if (attempts >= 25) {
      fallback();
      return;
    }

    window.setTimeout(function () {
      waitForPayU(callback, fallback, attempts + 1);
    }, 200);
  }

  function openPayUFromTheme(loginOnly, fallback) {
    waitForPayU(function () {
      window.payU.openModal(loginOnly);
    }, fallback || function () {});
  }

  function interceptPayULoginAndCheckout() {
    if (window.__mulsonPayUInterceptReady) return;
    window.__mulsonPayUInterceptReady = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      var accountLink = target.closest && target.closest('a[href*="/account"], a.payu-popup-js, a.payu-model-open-btn');
      var checkoutTrigger = target.closest && target.closest(
        'button[name="checkout"], .btn-checkout, .cart__checkout-button, a[href*="/checkout"]'
      );

      if (!accountLink && !checkoutTrigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (accountLink) {
        openPayUFromTheme(true, function () {
          window.location.href = accountLink.href || '/account';
        });
      } else {
        openPayUFromTheme(false, function () {
          var form = checkoutTrigger.closest && checkoutTrigger.closest('form');
          if (form) {
            HTMLFormElement.prototype.submit.call(form);
          } else {
            window.location.href = checkoutTrigger.href || '/checkout';
          }
        });
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.querySelector('button[name="checkout"], input[name="checkout"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      openPayUFromTheme(false, function () {
        HTMLFormElement.prototype.submit.call(form);
      });
    }, true);
  }

  function runMulsonFixes() {
    syncCartLabels();
    markEmptySocialLinks();
    interceptPayULoginAndCheckout();
  }

  document.addEventListener('DOMContentLoaded', runMulsonFixes);
  document.addEventListener('cart:updated', syncCartLabels);
  document.addEventListener('ajaxCart:updated', syncCartLabels);
  document.addEventListener('shopify:section:load', runMulsonFixes);
  setInterval(syncCartLabels, 1000);
})();
